import { createSlice } from '@reduxjs/toolkit'

const initialState = { module:[]}

const moduleSlice = createSlice({
  name: 'module',
  initialState,
  reducers: {
    addModule(state, action) {
       return action.payload
    }
  },
})

export const { addModule } = moduleSlice.actions
export default moduleSlice.reducer